import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { convertToUsdString } from '#src/app/shared/utils/currency';
import { calculateImpressions } from '#src/app/shared/utils/promote';

import { usePromoteFormData } from '../../../../../formContext/formData';
import { usePromoteFormState } from '../../../../../formContext/formState';

type Properties = Record<string, string | boolean | number | readonly string[] | readonly number[] | undefined>;

export function useMemoizedProperties(): Properties {
	const [{ amount }] = usePromoteFormState();
	const { currency, promotionSettings } = usePromoteFormData();

	const { amountToBaseUnits } = useI18n();

	const amountInUsdString = useMemo(
		() => convertToUsdString(amount, currency.exchangeRate),
		[amount, currency.exchangeRate],
	);

	const amountInBaseUnits = useMemo(
		() => amountToBaseUnits(amount, currency.code),
		[amountToBaseUnits, amount, currency.code],
	);

	const bonusImpressions = useMemo(
		() => calculateImpressions(amountInBaseUnits, promotionSettings.cpm),
		[amountInBaseUnits, promotionSettings.cpm],
	);

	const impressionsToFulfill = useMemo(
		() =>
			calculateImpressions(
				amountInBaseUnits,
				promotionSettings.cpm,
				promotionSettings.bonusCpm,
				promotionSettings.bonusThreshold,
			),
		[amountInBaseUnits, promotionSettings.bonusCpm, promotionSettings.bonusThreshold, promotionSettings.cpm],
	);

	return {
		amount: amountInUsdString,
		bonus_impressions: bonusImpressions,
		impressions_to_fulfill: impressionsToFulfill,
	};
}
